import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useRef } from 'react';
import { CustomIcon } from '../custom';
import '../style.css';
import { useTheme } from '@mui/material';
export const ConverterIconsFromStringToSVG = memo(function ConverterIconsFromStringToSVG(props) {
    const { iconToString, maintainColor, ...rest } = props;
    const theme = useTheme();
    const ResultParserSVG = iconToString &&
        new DOMParser().parseFromString(iconToString, 'text/xml').firstElementChild;
    const svgRef = useRef(null);
    const color = theme.palette.mode === 'dark'
        ? 'material-icons-dark path'
        : 'material-icons-light path';
    useEffect(() => {
        if (svgRef.current !== null && ResultParserSVG) {
            svgRef.current.appendChild(ResultParserSVG);
            svgRef.current.childNodes[0].setAttribute('width', '32px');
            svgRef.current.childNodes[0].setAttribute('height', '32px');
            if (maintainColor === true) {
                svgRef.current.childNodes[0].setAttribute('class', color);
            }
        }
    }, []);
    return _jsx(CustomIcon, { ...rest, ref: svgRef });
});
